import cardRetina from 'marketing-website/media/images/pages/about-us/02-card@2x.jpg';
import georgeRetina from 'marketing-website/media/images/pages/about-us/01-george@2x.jpg';
import heroRetina from 'marketing-website/media/images/pages/about-us/hero@2x.jpg';
import maxRetina from 'marketing-website/media/images/pages/about-us/03-max@2x.jpg';
import reyRetina from 'marketing-website/media/images/pages/about-us/04-rey@2x.jpg';
import zorastRetina from 'marketing-website/media/images/pages/about-us/05-zorast@2x.jpg';
import zorastSmallRetina from 'marketing-website/media/images/pages/about-us/Jobs@2x.png';
import valuesRetina from 'marketing-website/media/images/pages/about-us/ourValues@2x.jpg';

import carousel01Retina from 'marketing-website/media/images/pages/about-us/carousel-01@2x.jpg';
import carousel02Retina from 'marketing-website/media/images/pages/about-us/carousel-02@2x.jpg';
import carousel03Retina from 'marketing-website/media/images/pages/about-us/carousel-03@2x.jpg';
import carousel04Retina from 'marketing-website/media/images/pages/about-us/carousel-04@2x.jpg';
import carousel05Retina from 'marketing-website/media/images/pages/about-us/carousel-05@2x.jpg';
import carousel06Retina from 'marketing-website/media/images/pages/about-us/carousel-06@2x.jpg';
import carousel07Retina from 'marketing-website/media/images/pages/about-us/carousel-07@2x.jpg';

const assets = {
  hero: {
    alt: "We're on a mission to help the world bring ideas to life",
    maxWidth: 1390,
    src: heroRetina,
  },
  left: [
    {
      id: 0,
      alt: '',
      src: maxRetina,
      maxWidth: 675,
    },
    {
      id: 1,
      alt: '',
      src: georgeRetina,
      maxWidth: 345,
    },
    {
      id: 2,
      alt: '',
      src: reyRetina,
      maxWidth: 530,
    },
  ],
  right: [
    {
      id: 0,
      alt: '',
      src: zorastRetina,
      maxWidth: 675,
    },
    {
      id: 1,
      alt: '',
      src: cardRetina,
      maxWidth: 530,
    },
  ],
  values: {
    alt:
      "Started as a side-project in 2013, we're now home to over 2 million individuals and teams around the world who use Marvel to make ideas a reality.",
    maxWidth: 510,
    src: valuesRetina,
  },
  carousel: [
    {
      id: 0,
      alt: '',
      src: carousel01Retina,
      maxWidth: 406,
    },
    {
      id: 1,
      alt: '',
      src: carousel02Retina,
      maxWidth: 592,
    },
    {
      id: 2,
      alt: '',
      src: carousel03Retina,
      maxWidth: 325,
    },
    {
      id: 3,
      alt: '',
      src: carousel04Retina,
      maxWidth: 483,
    },
    {
      id: 4,
      alt: '',
      src: carousel05Retina,
      maxWidth: 520,
    },
    {
      id: 5,
      alt: '',
      src: carousel06Retina,
      maxWidth: 406,
    },
    {
      id: 6,
      alt: '',
      src: carousel07Retina,
      maxWidth: 325,
    },
  ],
  zorast: {
    alt: 'Open positions',
    maxWidth: 360,
    src: zorastSmallRetina,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/about-us/assets.js